import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=3d196dfe&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d196dfe')) {
      api.createRecord('3d196dfe', component.options)
    } else {
      api.reload('3d196dfe', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=3d196dfe&", function () {
      api.rerender('3d196dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YYq8VFPz1Yck/JS/videoIframe.vue"
export default component.exports